import React from 'react';
import AchievementStar, {STAR} from "../AchievementStar";

const QuizQuestionsLegend = props => {
    const {heading} = props;

    const BlockWithKeyText = props =>{
        const {star = STAR.NOT_ATTEMPTED} = props;

        return (<div style={{height:'24px'}} className='flex flex1 smallGap' role={'listitem'}>
                    <AchievementStar altText={star.ariaLabel} starFill={star.starFill} starColor={star.color}/>
                    <div aria-hidden className={'no-wrap'}>{star.display}</div>
                </div>);

    }

    return (
        <div className={'flex flexCentre'}>
            <div className='flexColumn padding--m padding-t--s padding-b--l ch-emph-block'>
                <div className='flexWrap flexCentre margin-b--m'>
                    <h2 className={'ch-std-font'}>{heading} key</h2>
                </div>
                <div className='flexWrap flexCentre flexAlignCentre largeGap' style={{lineHeight: '26px'}} role={"list"}>
                    <BlockWithKeyText star={STAR.NOT_ATTEMPTED} />
                    <BlockWithKeyText star={STAR.ATTEMPTED} />
                    <BlockWithKeyText star={STAR.ACHIEVED} />
                </div>
            </div>
        </div>
    )
}

export default QuizQuestionsLegend;